import React from "react";
import i18next from "i18next";

export function getDate(dt) {
  if (dt) {
    const date = new Date(dt);
    if (date != null) {
      dt = "";
      if (date.getDate() < 10) {
        dt += "0";
      }
      dt += `${date.getDate()}.`;
      if (date.getMonth() + 1 < 10) {
        dt += "0";
      }
      dt += `${date.getMonth() + 1}.${date.getFullYear()}`;
    }
  } else {
    dt = "";
  }

  return dt;
}
export function getTime(dt) {
  let ret = "";
  if (dt !== null && dt !== "") {
    const date = new Date(dt);
    ret = `${(date.getHours() < 10 ? "0" : "") + date.getHours()}:${
      date.getMinutes() < 10 ? "0" : ""
    }${date.getMinutes()}`;
  }
  return ret;
}

export function getDateTime(dt) {
  let ret = "";
  if (dt !== null && dt !== "") {
    ret = `${getDate(dt)} ${getTime(dt)}`;
  }
  return ret;
}

export function parseDate(str) {
  const ymd = str.split("-");
  return new Date(ymd[0], ymd[1] - 1, ymd[2]);
}

export function clearDate(date) {
  return date.replace(/\.\d+Z/, '').replace('T', ' ');
}

export function getToken() {
  return localStorage.getItem("user_token");
}

export function getUser() {
  return localStorage.getItem("email");
}

export const getBase64 = (file) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    // Read file content on file loaded event
    reader.onload = function (event) {
      const s = event.target.result;
      resolve(s.substring(s.indexOf(",") + 1));
    };

    // Convert data to base64
    reader.readAsDataURL(file);
  });

export const stringTruncate = (str, limit) => {
  if (str.length > limit) {
    return `${str.substr(0, limit - 1).trimRight()}…`;
  }
  return str;
};

// Часовой пояс устройства для заголовка N-Auto-Timezone: бэкенд записывает его
// новому пользователю при регистрации. Без заголовка всем доставался дефолт
// сервера (Europe/Moscow), что за пределами России всегда неверно.
export const deviceTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (e) {
    return "";
  }
};

// Плоское name/brandname у мультиязычных сущностей приходит null, когда бэкенд не смог
// заполнить его из текущей локали: заполнена только другая вкладка (например, в китайской
// сборке ввели английское имя). У пользователей плоское имя может быть просто не заполнено.
// Раньше это стоило белого экрана: фильтры списков звали .toLowerCase() прямо на поле,
// и страница спикеров переставала открываться после добавления такого спикера.
export const flatOrI18n = (item, field = "name") => {
  if (!item) return "";
  if (item[field]) return item[field];

  const i18n = item[`${field}_i18n`];
  if (i18n && typeof i18n === "object") {
    const found = Object.values(i18n).find((v) => v);
    if (found) return found;
  }

  return "";
};

// canBePremium приходит с бэка объектом {status, price?, until?}; на переходный
// период (бэк ещё не обновлён) — легаси-строкой: статусом («already», «disabled in
// tariff», «low balance», «conference finished») или ценой опции («3000.00»).
// Приводим всё к объекту, чтобы страница и типы билетов сравнивали только
// premiumState.status. premiumDate — conference.premium, дата окончания для
// легаси-«already» (в новом контракте until приходит внутри объекта).
// Пустое значение (не загрузилось) остаётся строкой «» — sentinel.
export const normalizePremiumState = (value, premiumDate) => {
  if (value && typeof value === "object") {
    return { ...value, status: value.status || "" };
  }
  if (typeof value === "number") {
    return { status: "ok", price: String(value) };
  }
  if (typeof value === "string" && value) {
    if (/^\d+(\.\d+)?$/.test(value)) {
      return { status: "ok", price: value };
    }
    const status = value.toLowerCase().replace(/[^a-z0-9]+/g, "_");
    return {
      status,
      until: status === "already" ? premiumDate : undefined,
    };
  }
  return "";
};

// Перевод статуса опции «Без ограничений» (премиума): ключи premium_state_*,
// фолбэк — исходное значение. Нужно в двух местах — на карточке мероприятия
// и рядом с ценой билета, поэтому живёт здесь, а не в странице.
export const premiumStateText = (state) => {
  if (state === "" || state === null || state === undefined) return "";

  const key =
    "premium_state_" +
    String(state)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_");

  return i18next.t(key, { defaultValue: String(state) });
};

// Имена системных ролей приходят с бэка идентификаторами («admin», «place_manager»)
// и выводились как есть — в китайском интерфейсе это латиница посреди иероглифов.
// Роли, заведённые организатором, называет он сам: переводить их нечем, defaultValue
// отдаёт имя без изменений.
export const roleTitle = (name) => {
  if (!name) return "";

  return i18next.t("system_role_" + name, { defaultValue: String(name) });
};

// Приводит введённый адрес к виду, который принимает валидатор `url` Laravel:
// без схемы («test.com/video») бэкенд отвечает 422 «The url must be a valid URL».
// Люди схему почти никогда не пишут, а сообщение приходит на английском и без
// указания поля — со стороны это выглядит как «кнопка не работает» (мероприятие
// не сохраняется, «Опубликовать» остаётся серой).
// Пустое значение остаётся пустым: поле необязательное. Один placeholder
// «https://» без адреса тоже считается пустым — иначе на бэк уходит схема без хоста.
export const normalizeUrl = (str) => {
  if (typeof str !== "string") return str;

  const trimmed = str.trim();
  if (!trimmed || /^https?:\/\/$/i.test(trimmed)) return "";
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)) return trimmed;

  return `https://${trimmed}`;
};

export const nl2br = (str) => {
  if (!str) {
    return "";
  }
  return str.split("\n").map((item, key) => (
    <span key={key}>
      {item}
      <br />
    </span>
  ));
};
